import { CRON_CONFIG_FORM_KEY, CRON_CONFIG_SCHEMAS } from '../helpers/cronConfigSchemas';

const isPlainObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);

export const getCronConfigSchema = (cronName) => CRON_CONFIG_SCHEMAS[cronName] || null;

export const parseCronConfig = (value) => {
  if (isPlainObject(value)) return value;
  if (typeof value !== 'string' || !value.trim()) return {};
  try {
    const parsed = JSON.parse(value);
    return isPlainObject(parsed) ? parsed : {};
  } catch (e) {
    return {};
  }
};

export const unpackCronConfig = (record) => {
  const schema = getCronConfigSchema(record?.cron_name);
  if (!schema) return {};
  const parsed = parseCronConfig(record.config);
  const fields = {};
  schema.forEach(({ key, defaultValue }) => {
    fields[key] = parsed[key] ?? defaultValue;
  });
  return { [CRON_CONFIG_FORM_KEY]: fields };
};

export const packCronConfig = (data, { previousData } = {}) => {
  const cronName = data.cron_name ?? previousData?.cron_name;
  // details is runtime state owned by the crons: never send back the copy loaded with the form
  const { [CRON_CONFIG_FORM_KEY]: fields, details, ...rest } = data;
  const schema = getCronConfigSchema(cronName);
  if (!schema) return rest;
  const packed = {};
  schema.forEach(({ key, type, defaultValue }) => {
    if (type === 'number') {
      packed[key] = Number(fields?.[key] ?? defaultValue);
    } else if (type === 'reports') {
      packed[key] = (Array.isArray(fields?.[key]) ? fields[key] : defaultValue).map(Number);
    }
  });
  return { ...rest, config: JSON.stringify({ ...parseCronConfig(data.config), ...packed }) };
};
